import { Plugin } from "prosemirror-state";
import { ReactPluginView } from "../../react/react-plugin-view";
import { MenuView } from "./components/MenuView";
export function tableMenu(portalContainer) {
    return new Plugin({
        view: ReactPluginView.create({ portalContainer, component: MenuView }),
    });
}
